import { Controller } from "@hotwired/stimulus";
import { displayCustomerDetails } from "../../components/sales_invoices/display_customer_details";

export default class extends Controller {
  displayDetails(e) {
    const customer = JSON.parse(e.detail.customer);
    displayCustomerDetails(customer.id);
  }
}
